<template>
  <div class="box">
    <div class="card-content">
      <div class="card-left">
        <div class="icon-container">
          <svg
            class="icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <div class="text-content mt-3">
          <h3>FAQ History</h3>
          <p>{{ getMessageCount() }} messages</p>
        </div>
      </div>
      <b-button class="see-all-btn" @click="handleShowSideberHistory">
        See All
      </b-button>
    </div>
    <ChatShopeeHistory
      ref="ChatShopeeSideBarHistory"
      :messageId="con.message"
    />
  </div>
</template>

<script>
import ChatShopeeHistory from "../ChatShopeeHistory.vue";
export default {
  props: {
    con: {
      required: false,
      type: Object
    }
  },
  components: {
    ChatShopeeHistory
  },
  data() {
    return {};
  },
  methods: {
    getMessageCount() {
      let count = this.con.message.split(",");
      count.splice(0, 1);
      return count.length;
    },
    handleShowSideberHistory() {
      this.$refs.ChatShopeeSideBarHistory.show();
    }
  }
};
</script>

<style scoped>
.box {
  max-width: 480px;
}

.card-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card-left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.icon-container {
  width: 3rem;
  height: 3rem;
  background-color: #f3f4f6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon {
  width: 1.25rem;
  height: 1.25rem;
  color: #4b5563;
  stroke-width: 2;
}

.text-content h3 {
  font-size: 0.875rem;
  font-weight: 500;
  color: #111827;
  margin-bottom: 0.25rem;
}

.text-content p {
  font-size: 0.75rem;
  color: #6b7280;
}

.see-all-btn {
  font-size: 0.875rem;
  font-weight: 500;
  color: #832abf;
  background: none;
  border: none;
  padding: 0.375rem 0.75rem;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.see-all-btn:hover {
  color: #832abf;
}

.see-all-btn:focus {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}
</style>
